import React, { useState } from 'react';
import 'react-phone-input-2/lib/style.css';
import styled from 'styled-components';

import { InputPhone } from '../../../components/Form/InputPhone/InputPhone';

const StyledPhoneInput = styled.div`
  .form-control {
    color: ${(props) => (props?.isInvalid ? '#F20606' : '#000')};
  }
`;

const SendPhoneNumber = ({ error, setError, onSignInSubmit, setPhone, isLoading }) => {
  const [clearPhone, setClearPhone] = useState('');
  const handleChange = ({ code, phone }) => {
    setPhone(`${code}${phone}`);
    setClearPhone(phone);
  };

  const isSubmitBtnDisable =
    !clearPhone?.length || clearPhone?.length < 8 || clearPhone?.length > 10 || isLoading;

  return (
    <>
      <h3 className="phone-number">Phone number</h3>
      <form onSubmit={onSignInSubmit}>
        <StyledPhoneInput isInvalid={error}>
          <InputPhone onChange={handleChange} isInvalid={error} />
        </StyledPhoneInput>
        {error && <p className="error_text">Wrong mobile phone number </p>}
        <button
          className="btn"
          type="submit"
          disabled={isSubmitBtnDisable}
          onClick={() => setError(false)}
        >
          {isLoading ? 'Loading...' : 'Continue'}
        </button>
      </form>
    </>
  );
};

export default SendPhoneNumber;
